import { createSlice } from '@reduxjs/toolkit'

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
    },
    reducers: {

        update: (state, action) => {
            state.user = action.payload
        },
    },
})

export const { update } = authSlice.actions

export default authSlice.reducer